import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import anychart from 'anychart'

import uuid from '../../../services/uuid'

import 'anychart/dist/css/anychart-ui.min.css'
import 'anychart/dist/fonts/css/anychart-font.min.css'

anychart.licenseKey('mailup.com-761e5414-30aca999')
//  non funziona...
anychart.theme({ chart: { credits: { enabled: false } } })

function getBackgroundColor () {
  return document.documentElement.style.getPropertyValue('--backgrounds-boxcolor') || '#FFFFFF'
}

const GaugeChart = ({ id, data, minimum, maximum, color }) => {
  const componentId = id || uuid()
  const containerElement = useRef(null)
  const [backgroundColor, setBackgroundColor] = useState(getBackgroundColor())

  // on mount
  useEffect(() => {
    //  console.log('### gauge background-color', backgroundColor)
    const stage = anychart.graphics.create(componentId)
    const chart = anychart.gauges.circular()
    const axis = chart.axis()

    stage.circle(36, 36, 19).stroke(null).fill(backgroundColor).zIndex(5)

    chart.credits().enabled(false)
    chart.data([data])
    chart.fill('#F2F0F0').stroke(null).width(72).padding(0).margin(0)
    chart.tooltip(false)
    chart.background().fill(backgroundColor)

    axis.radius(150).width(0).fill(null)
    axis.labels().enabled(false)

    axis.scale().minimum(minimum)
    axis.scale().maximum(maximum)

    chart.bar(0).dataIndex(0).radius(85).width(54).fill(color).stroke(null)
    chart.container(stage).draw()
    //
    if (containerElement && containerElement.current) {
      const svgElement = containerElement.current.querySelector('svg')
      if(svgElement !== null) {
        svgElement.setAttribute('viewBox', `0 0 ${svgElement.clientWidth} ${svgElement.clientHeight}`)
      }
      
    }
    //
    const mutationObserver = new window.MutationObserver(handleBackgroundColoVar)

    mutationObserver.observe(document.documentElement, {
      attributes: true,
      attributesFilter: ['style'],
      subtree: false,
      childList: false
    })

    return () => {
      chart.dispose()
      mutationObserver.disconnect()
    }
  }, [data, backgroundColor])

  function handleBackgroundColoVar () {
    setBackgroundColor(getBackgroundColor())
  }

  return (
    <div id={componentId} style={{ maxWidth: '72px', height: '72px' }} ref={containerElement} />
  )
}

GaugeChart.defaultProps = {
  color: '#000'
}
GaugeChart.propTypes = {
  id: PropTypes.string,
  data: PropTypes.number,
  minimum: PropTypes.number,
  maximum: PropTypes.number,
  color: PropTypes.string
}

export default GaugeChart
